var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1998 13.0876C10.3005 15.6678 5.89296 15.542 3.14561 12.8006C0.323602 9.97866 0.279943 5.41688 3.04743 2.54146C5.81491 -0.333958 10.4419 -0.333958 13.3025 2.2476C16.163 4.82915 16.274 9.25054 14.3782 11.7952L20.7246 18.1419C20.8876 18.3055 21.2533 19.0382 20.7246 19.4343C20.196 19.8303 19.7098 19.5972 19.5462 19.4343L13.1998 13.0876ZM14.3938 7.62083C14.3938 5.16613 12.9152 2.95313 10.6474 2.01376C8.37963 1.07439 5.7693 1.59364 4.03364 3.32939C2.89085 4.46507 2.24823 6.00968 2.24823 7.62083C2.24823 9.23198 2.89084 10.7766 4.03363 11.9123C5.7693 13.648 8.37963 14.1673 10.6474 13.2279C12.9152 12.2885 14.3938 10.0755 14.3938 7.62083Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_488_5365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1998 13.0876C10.3005 15.6678 5.89296 15.542 3.14561 12.8006C0.323602 9.97866 0.279943 5.41688 3.04743 2.54146C5.81491 -0.333958 10.4419 -0.333958 13.3025 2.2476C16.163 4.82915 16.274 9.25054 14.3782 11.7952L20.7246 18.1419C20.8876 18.3055 21.2533 19.0382 20.7246 19.4343C20.196 19.8303 19.7098 19.5972 19.5462 19.4343L13.1998 13.0876ZM14.3938 7.62083C14.3938 5.16613 12.9152 2.95313 10.6474 2.01376C8.37963 1.07439 5.7693 1.59364 4.03364 3.32939C2.89085 4.46507 2.24823 6.00968 2.24823 7.62083C2.24823 9.23198 2.89084 10.7766 4.03363 11.9123C5.7693 13.648 8.37963 14.1673 10.6474 13.2279C12.9152 12.2885 14.3938 10.0755 14.3938 7.62083Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_488_5365)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.1e081b8058c429b4f231079ff342e3b1.svg";
export { ForwardRef as ReactComponent };